// Context
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useAuth } from "../../hooks/useAuth";
import apiAdmin from "../../services/apiAdmin";
import moment from "moment";
import { useTranslation } from "react-i18next";

function ModalTicketList({ setSelectedTicket, setCreateTicket }) {
  const { t } = useTranslation();
  const { auth } = useAuth();
  const [openTickets, setOpenTickets] = useState();
  const [closedTickets, setClosedTickets] = useState();
  const [showClosedTickets, setShowClosedTickets] = useState();

  useEffect(() => {
    if (auth.user) fetchTickets();
    // eslint-disable-next-line
  }, [auth.user]);

  const fetchTickets = async () => {
    let res;
    try {
      res = await apiAdmin.getTickets();
    } catch (e) {
      // The admin interceptor throws on every non-2xx, so the else branch below
      // is never the failure path: unhandled, the list just never rendered and
      // nobody was told. Message only -- never the raw axios error.
      console.error("Tickets fetch failed -", e?.message || e);
      toast.error(t("tickets.list.errorFetching"));
      return;
    }
    if (res.status === 200) {
      setOpenTickets(res.data.filter((t) => t.status !== "Closed" && t.status !== "Invalid"));
      setClosedTickets(res.data.filter((t) => t.status === "Closed" || t.status === "Invalid"));
    } else {
      toast.error(t("tickets.list.errorFetching"));
    }
  };

  const createTicket = () => {
    setCreateTicket(true);
  };

  const renderTicket = (ticket) => (
    <div className="ticket-row" key={ticket.id} onClick={() => setSelectedTicket(ticket)}>
      <div className="ticket-left">
        {ticket.toRead && <div className="badge-to-read left"></div>}
        <div className="ticket-code">#TKT-{ticket.code}</div>
        <div className="ticket-date">{moment(new Date(ticket.date)).fromNow()}</div>
      </div>
      <div className="ticket-status">
        <div
          className={
            "badge " +
            (ticket.status === "Created" ? "blue" : "") +
            (ticket.status === "In Progress" ? "light-blue" : "") +
            (ticket.status === "Closed" ? "green" : "") +
            (ticket.status === "Invalid" ? "red" : "")
          }
        >
          {ticket.status}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {openTickets && (
        <>
          {openTickets.length === 0 ? (
            <h4>{t("tickets.list.noOpenTickets")}</h4>
          ) : (
            <>
              <h4>{t("tickets.list.openTickets", { count: openTickets.length })}</h4>
              {openTickets.map((ticket) => renderTicket(ticket))}
            </>
          )}
        </>
      )}

      {closedTickets && (
        <>
          {closedTickets.length > 0 && (
            <div className="mt-50">
              {!showClosedTickets ? (
                <div className="link" onClick={() => setShowClosedTickets(true)}>
                  {t("tickets.list.showClosedTickets", { count: closedTickets.length })}
                </div>
              ) : (
                <>
                  <div className="mb-20">
                    <div className="link " onClick={() => setShowClosedTickets(false)}>
                      {t("tickets.list.hideClosedTickets")}
                    </div>
                  </div>
                  {closedTickets.map((ticket) => renderTicket(ticket))}
                </>
              )}
            </div>
          )}
        </>
      )}

      <div className="modal-actions">
        <button className="btn btn-primary" onClick={createTicket}>
          {t("tickets.list.newTicketRequest")}
        </button>
      </div>
    </>
  );
}

export default ModalTicketList;
